import Button from "@/components/Button";
import { ActionShortcutTooltip } from "../KeyboardShortcutHint";
import { type Platform } from "../../hooks/usePlatformDetection";
import { globalSearchAriaShortcut } from "@/lib/keyboardShortcuts";

export interface SearchButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  testId?: string;
  /** Force display of specific platform keyboard shortcut (for testing/stories only) */
  forcePlatform?: Platform;
}

export default function SearchButton({
  onClick,
  disabled = false,
  testId = "search-button",
  forcePlatform
}: SearchButtonProps) {
  return (
    <ActionShortcutTooltip
      label="Search"
      hints={[{ keyLabel: "k", testId: "global-find-shortcut-hint", forcePlatform }]}
    >
      <Button
        variant="squared"
        icon="search"
        iconWeight={800}
        onClick={onClick}
        disabled={disabled}
        testId={testId}
        ariaLabel="Search"
        ariaKeyShortcuts={globalSearchAriaShortcut()}
      />
    </ActionShortcutTooltip>
  );
}
